import React from "react"
// import { navigate } from "gatsby"
// import { useForm } from "react-hook-form"
import { TbPhoneCall } from "react-icons/tb"
import { BsChevronRight } from "react-icons/bs"

export default function BookForm() {
  const services = [
    {
      name: "Manicure Services",
      description: "",
      slug: "manicure",
      isActive: true,
    },
    {
      name: "Pedicure Services",
      description: "",
      slug: "pedicure",
      isActive: true,
    },
    {
      name: "Waxing Services",
      description: "",
      slug: "waxing",
      isActive: true,
    },
  ]

  return (
    <form
      id="bookingForm"
      method="POST"
      action="/thankyou/"
      data-netlify="true"
      netlify-honeypot="bot-field"
      name="booking"
    >
      <input type="hidden" name="form-name" value="booking" />
      <input type="text" name="bot-field" className="hidden" />

      <div className="sm:overflow-hidden">
        <div className="bg-white py-6 px-4 space-y-6 sm:p-6">
          <div>
            <h3 className="text-lg leading-6 font-medium text-slate-900 font-playfaird">
              Book Your Appointment
            </h3>
            <p className="mt-1 text-sm text-slate-500">
              Choose the desired services and provide your contact information.
              Upon receiving your request, I'll reach out to arrange a
              convenient time.
            </p>
          </div>

          <fieldset>
            <legend className="text-base font-medium text-slate-900 font-playfaird">
              Please Choose Services
            </legend>
            <div className="mt-4 space-y-4">
              {services.map(service => (
                <div key={service.slug} className="flex items-start">
                  <div className="h-5 flex items-center">
                    <input
                      id={service.slug}
                      name={service.slug}
                      type="checkbox"
                      className={`focus:ring-amber-200 h-4 w-4 text-amber-200 border-slate-300 rounded ${
                        service.isActive ? "" : "cursor-not-allowed"
                      }`}
                      defaultChecked={service.checked}
                      disabled={service.isActive ? false : true}
                    />
                  </div>
                  <div className="ml-3 text-sm">
                    <label
                      htmlFor={service.slug}
                      className={`font-medium ${
                        service.isActive ? "text-slate-700" : "text-slate-300"
                      }`}
                    >
                      {service.name}
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </fieldset>
          <fieldset className="mt-6">
            <legend className="text-base font-medium text-slate-900 font-playfaird">
              Your Contacts
            </legend>
            <div className="mt-4 space-y-4">
              <div>
                <label
                  htmlFor="tel"
                  className="block text-sm font-medium text-slate-700"
                >
                  Your Phone
                </label>
                <div className="mt-1 relative rounded-sm shadow-sm">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <TbPhoneCall
                      className="h-5 w-5 text-slate-400"
                      aria-hidden="true"
                    />
                  </div>
                  <input
                    type="tel"
                    name="tel"
                    id="formTel"
                    className="focus:ring-amber-200 focus:border-amber-200 block w-full pl-10 sm:text-sm border-slate-300 rounded-sm text-sm"
                    placeholder="your phone here"
                    required
                  />
                </div>
              </div>

              <div>
                <div className="flex justify-between">
                  <label
                    htmlFor="name"
                    className="block text-sm font-medium text-slate-700"
                  >
                    Your Name
                  </label>
                  <span className="text-xs text-slate-500" id="name-optional">
                    optional
                  </span>
                </div>
                <div className="mt-1">
                  <input
                    type="text"
                    name="name"
                    id="formName"
                    className="shadow-sm focus:ring-amber-200 focus:border-amber-200 block w-full sm:text-sm border-slate-300 rounded-sm text-sm"
                    placeholder="Name"
                    aria-describedby="name-optional"
                  />
                </div>
              </div>
            </div>
          </fieldset>
          <button
            type="submit"
            className="py-3 px-8 font-playfaird tracking-wider uppercase flex items-center justify-center rounded-sm whitespace-nowrap bg-amber-200 text-slate-900 border border-transparent shadow-sm text-sm font-medium hover:bg-amber-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-200"
          >
            <span>Send</span>
            <BsChevronRight className="ml-2 h-4" />
          </button>
        </div>

        {/* <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
          <button
            onClick={closeModal}
            type="button"
            className="py-3 px-8 font-playfaird tracking-wider uppercase flex items-center justify-center rounded-sm whitespace-nowrap text-slate-900 border border-slate-300 hover:border-slate-500 shadow-sm text-sm font-medium  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-200"
          >
            Cancel
          </button>
        </div> */}
      </div>
    </form>
  )
}
